import type { DispatchInProgressUrlState } from './types';

export const DEFAULT_URL_STATE: DispatchInProgressUrlState = {
  consignmentNumber: '',
  dateFrom: '',
  dateTo: '',
  search: '',
  sortBy: 'actualDispatchTime',
  sortDir: 'ASC',
  size: '15'
};
